export default __webpack_public_path__ + "static/media/shipping.a5c7b66d.svg";